<template>
  <main class="container px-3">
    <h4 class="nes blue">Hi! Have a great one! </h4>
    <code class="text-primary nes"><span class="h3">👋</span> from your friends at <a href="https://xrpl-labs.com" target="_blank"><u>XRPL Labs</u></a>.</code>
    <div class="mt-4">
      Simple technical TX / ledger / object / hash explorer.
    </div>
    <div class="mt-4">
      <div class="alert alert-success shadow-sm">
        You can view (JSON, technical (!) explorer) ledgers, transactions,
        meta, etc. and <b>click through, on ledger numbers, hashes, transaction hashes, accounts</b>, etc.
      </div>
    </div>
    <div class="mt-4">
      Click a ledger or search for something (account, hash, ...)
    </div>
  </main>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
</style>
